const KeyboardHelper = {
  /**
   * [isTab return true if the event is a tab event]
   * @param  {[type]}  event [keydown devent]
   * @return {Boolean}   [true or false]
   */
  isTab(event) {
    return (event && event.keyCode === 9 && !event.shiftKey);
  },

  /**
   * [isTabBack return true if shoft tab was pressed or tab back]
   * @param  {[type]}  event [keydown devent]
   * @return {Boolean}   [true or false]
   */
  isTabBack(event) {
    return event && event.shiftKey && event.keyCode === 9;
  }
};

export default KeyboardHelper;
